const PHYSICAL_EXAM_GRID_COLUMNS = "300px 1fr";

const PHYSICAL_EXAM_GRID_COLUMNS_SUB_GROUP = "500px 1fr";

export { PHYSICAL_EXAM_GRID_COLUMNS, PHYSICAL_EXAM_GRID_COLUMNS_SUB_GROUP };
